import { axiosInstance } from "../../repository/Repository";
import { GET_NOTIFICATIONS, READ_NOTIFICATIONS, NOTIFICATIONS_PENDING, NOTIFICATIONS_REJECTED } from "./types";
import moment from 'moment';

export const getNotifications = () => async (dispatch) => {
    dispatch({ type: NOTIFICATIONS_PENDING });
    try {
        const response = await axiosInstance.get('/inAppnotifications/unviewed');
        // Filter: Remove viewed notifications older than 24 hours
        const filteredNotifications = response.data.filter(notif => {
            const createdTime = moment(notif.createdAt);
            const hoursOld = moment().diff(createdTime, 'hours');
            if (!notif.viewed) return true;
            if (notif.viewed && hoursOld < 24) return true;
            return false;
        });
        dispatch({ type: GET_NOTIFICATIONS, payload: filteredNotifications });
        return filteredNotifications;
    } catch (error) {
        console.log('Error getting notification');
        dispatch({ type: NOTIFICATIONS_REJECTED });
        throw error;
    }
};

export const setReadNotificationsLoader = (val) => async (dispatch) => {
    dispatch({ type: READ_NOTIFICATIONS, payload: val });
};

export const readNotifications = (id, onSuccess = () => { }) => async (dispatch) => {
    dispatch(setReadNotificationsLoader(true));
    try {
        const response = await axiosInstance.put(`/inAppnotifications/${id}`);
        dispatch(setReadNotificationsLoader(false));
        onSuccess()
        return response.data;
    } catch (error) {
        console.log('Error marking notification as viewed');
        dispatch(setReadNotificationsLoader(false));
        throw error;
    }
};